// The social window and personal feed page independently. A Dojo day must not
// report "You: None" until the personal source has consumed that entire day.
// The activity endpoint extends every source page to the end of its oldest
// created_at day; an exhausted feed covers all remaining days.
function coveredSourceDay(value, oldestConsumedCreatedAt, hasMore, getDateKey) {
  if (!hasMore) return true;
  const oldest = oldestConsumedCreatedAt && getDateKey(oldestConsumedCreatedAt);
  const sourceDay = value && getDateKey(value);
  return Boolean(oldest && /^\d{4}-\d{2}-\d{2}$/.test(oldest)
    && sourceDay && /^\d{4}-\d{2}-\d{2}$/.test(sourceDay) && sourceDay >= oldest);
}

export function coveredDojoSourceActivities(activities, oldestConsumedCreatedAt, hasMore, getDateKey) {
  return activities.filter(activity => coveredSourceDay(
    activity.created_at, oldestConsumedCreatedAt, hasMore, getDateKey,
  ));
}

export function coveredDojoDays(byDate, oldestConsumedCreatedAt, hasMore, getDateKey) {
  if (!hasMore) return byDate;
  const oldest = oldestConsumedCreatedAt && getDateKey(oldestConsumedCreatedAt);
  if (!oldest || !/^\d{4}-\d{2}-\d{2}$/.test(oldest)) return {};
  return Object.fromEntries(Object.entries(byDate).filter(([day]) => day >= oldest));
}
